import type { MaterializedMenuProduct } from '@iheartjane/data-access';
import type { SmartSort, IntendedDisplay } from '@iheartjane/dm-sdk';
import type {
  BannerCustomImageAdSlide,
  CustomImageAdProduct,
} from '@iheartjane/menu';

interface BuildCustomImageAdSlideArgs {
  instance: SmartSort<MaterializedMenuProduct>;
  intendedDisplay: IntendedDisplay;
  onImageClick?: (brandName: string) => void;
  onProductClick?: (product: CustomImageAdProduct) => void;
}

export const buildCustomImageAdSlide = ({
  instance,
  intendedDisplay,
  onImageClick,
  onProductClick,
}: BuildCustomImageAdSlideArgs): BannerCustomImageAdSlide | undefined => {
  if (!instance.products.length) {
    return undefined;
  }

  const customImageData = instance.customImages.find(
    (image) => image.intendedDisplay === intendedDisplay
  );

  if (!customImageData) {
    return undefined;
  }

  return {
    customImageData,
    id: 'carousel-image-ad',
    kind: 'customImageAd',
    onImageClick,
    onProductClick,
    products: instance.products.map((product) => {
      const { attributes } = product;

      return {
        aggregate_rating: attributes.aggregate_rating ?? 0,
        brand: attributes.brand ?? '',
        category: attributes.category ?? '',
        clickHandler: () => void product.click(),
        image_urls: attributes.image_urls ?? [],
        name: attributes.name,
        pdpUrl: `/products/${attributes.product_id}`,
        product_id: attributes.product_id,
        review_count: attributes.review_count ?? 0,
      };
    }),
  };
};
